import {Component, Input} from '@angular/core';
import {
  CategoryItem,
  Competitor,
  CompetitorResults, Country,
  EventItem,
  Lookups,
  Race, RaceAdditionalPricingItem, RaceCommercialItem, Waypoint
} from '@model';
import {ExportService, RaceService} from '@services';
import {AbstractComponent} from '@components';
import {RaceAdditionalPricingItemsResolver, RaceCommercialItemsResolver} from "@resolvers";

@Component({
  selector: 'app-race-management-component',
  templateUrl: './race-management-component.component.html',
  styleUrls: ['./race-management-component.component.scss']
})
export class RaceManagementComponentComponent extends AbstractComponent {
  @Input() waypointList: Waypoint[] = [];
  @Input() genders: Lookups[] = [];
  @Input({required: true}) languages: Lookups[] = [];
  @Input({required: true}) countries: Country[] = [];
  @Input() competitors: Competitor[] = [];
  @Input() results: CompetitorResults[] = [];
  @Input() race: Race | undefined;
  @Input() eventItem: EventItem | undefined;
  @Input() categories: CategoryItem[] = [];
  @Input() raceCommercialItems: RaceCommercialItem[] = []
  @Input() raceAdditionalItems: RaceAdditionalPricingItem[] = []

  constructor(public raceService: RaceService, private exportService: ExportService) {
    super();
  }

  downloadStartList() {
    this.exportService.downloadStartList(this.eventItem!.id!, this.race!.id!);
  }
}
